import React from 'react'
import { notAgend } from '../../../../assets/'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { Services } from '../../../../services'
import RouterHook from '../../../../contexts/RouterHook'

export default function PixError() {
  const serverRouter = RouterHook()
  const { userUCtx } = React.useContext(UsuarioContext)

  function StartHomePage() {
    let query = ''
    if (userUCtx.usuario.cidade && userUCtx.usuario.estado) {
      query = `${
        userUCtx.usuario.estado.length === 2 ? userUCtx.usuario.estado : Services.ReturnSiglaEstado(userUCtx.usuario.estado)
      }-${Services.RemoveCaracteresEspeciais(userUCtx.usuario.cidade)}`.toLowerCase()
    } else {
      query = ':localizacao'
    }
    serverRouter('home', query)
  }

  return (
    <>
      <h2 className='title-pag-me-pix' style={{ fontSize: '24px' }}>
        Pagamento não reconhecido
      </h2>
      <div className='contain-internal-pix'>
        <img className='img-pag-me-pix' src={notAgend} alt='Pagamento não reconhecido' />
        <h3 className='contain-informacoes-pix-paragrafo'>
          Parece que ocorreu um erro ao processar o sue pagamento, por favor verifique sua conexão e tente novamente.
        </h3>
        <button className='btt-pag-me-pix-agendar' onClick={() => StartHomePage()}>
          Voltar para a tela inicial
        </button>
      </div>
    </>
  )
}
